import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, go, logo } from './util';

/**
 * /businesses/review (moderators): new listings to approve or send back, and verification requests to check
 * against the registry (CAC's public search for Nigeria) before marking them verified or not.
 */
export default class BusinessReview extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.q = null;
    this.notes = {};
    this.error = null;
    app.request({
      method: 'GET',
      url: api('/businesses-queue'),
      errorHandler: () => {}
    }).then(r => this.q = r).catch(e => this.error = e && e.response && e.response.message || 'Moderators only.').then(() => m.redraw());
  }
  decide(b, action, yes) {
    const note = (this.notes[action + b.id] || '').trim();
    if (!yes && !note) {
      this.notes['err' + action + b.id] = 'Say why, so the owner can fix it.';
      return;
    }
    this.busy = action + b.id;
    app.request({
      method: 'POST',
      url: api('/businesses/' + b.id + '/' + action),
      body: action === 'review' ? {
        approve: yes,
        note
      } : {
        ok: yes,
        note
      },
      errorHandler: () => {}
    }).then(r => this.q = {
      listings: r.listings,
      verifications: r.verifications
    }).catch(() => this.error = 'That didn’t work. Please try again.').then(() => {
      this.busy = null;
      m.redraw();
    });
  }
  item(b, action) {
    const c = b.contact || {};
    const r = b.registration || {};
    const k = action + b.id;
    return m("div", {
      className: "VEvt-card VBizR-item"
    }, m("div", {
      className: "VBizR-head"
    }, logo(b, 44), m("div", null, m("a", {
      href: '/businesses/' + b.slug,
      onclick: go('/businesses/' + b.slug)
    }, m("strong", null, b.name)), m("div", {
      className: "VBiz-meta"
    }, [b.category && b.category.name, b.place].filter(Boolean).join(' · ')), m("div", {
      className: "VBiz-meta"
    }, "By ", (b.team || []).filter(t => t.role === 'owner').map(t => t.username).join(', ') || 'unknown'))), action === 'review' ? m("div", {
      className: "VBizR-body"
    }, b.about ? m("p", null, b.about) : null, c.url ? m("p", null, m("i", {
      className: "fas fa-globe"
    }), " ", m("a", {
      href: c.url,
      target: "_blank",
      rel: "noopener nofollow"
    }, c.url)) : null, b.services && b.services.length ? m("p", {
      className: "VBiz-meta"
    }, "Services: ", b.services.join(', ')) : null) : m("div", {
      className: "VBizR-body"
    }, m("p", null, m("strong", null, r.number), " \xB7 ", r.name, " \xB7 registered in ", r.country), r.country === 'NG' ? m("p", {
      className: "VBiz-meta"
    }, "Check it on the ", m("a", {
      href: "https://search.cac.gov.ng/home",
      target: "_blank",
      rel: "noopener"
    }, "CAC public search"), ": the number and name must match, and the status should be active.") : null), m("input", {
      className: "VBiz-select VBizR-note",
      placeholder: action === 'review' ? 'Note to the owner (needed to send it back)' : 'Why it isn’t verified (needed to decline)',
      value: this.notes[k] || '',
      oninput: e => {
        this.notes[k] = e.target.value;
        delete this.notes['err' + k];
      }
    }), this.notes['err' + k] ? m("p", {
      className: "VBiz-error"
    }, this.notes['err' + k]) : null, m("div", {
      className: "VEvt-actions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.busy === k,
      onclick: () => this.decide(b, action, true)
    }, action === 'review' ? 'Approve' : 'Mark verified'), m(Button, {
      className: "Button",
      onclick: () => this.decide(b, action, false)
    }, action === 'review' ? 'Send back' : 'Not verified')));
  }
  view() {
    if (this.error && !this.q) return m("div", {
      className: "VEvt VEvt-empty"
    }, m("p", null, this.error));
    if (!this.q) return m(LoadingIndicator, null);
    const {
      listings,
      verifications
    } = this.q;
    return m("div", {
      className: "VEvt VEvtD VBizR"
    }, m("div", {
      className: "VEvtD-bar"
    }, m("a", {
      href: "/businesses",
      onclick: go('/businesses')
    }, "\u2190 Businesses")), m("h1", {
      className: "VBizR-title"
    }, "Review businesses"), this.error ? m("p", {
      className: "VBiz-error"
    }, this.error) : null, m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "New listings (", listings.length, ")"), listings.length ? listings.map(b => this.item(b, 'review')) : m("p", {
      className: "VBiz-muted"
    }, "Nothing waiting.")), m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "Verification requests (", verifications.length, ")"), verifications.length ? verifications.map(b => this.item(b, 'verify')) : m("p", {
      className: "VBiz-muted"
    }, "Nothing waiting.")));
  }
}
flarum.reg.add('voucha-community', 'forum/businesses/BusinessReview', BusinessReview);